import { useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { toast } from "sonner";
import { errText } from "../lib/errors";
import { Mail, ArrowLeft } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(errText(err) || "Gönderilemedi");
    } finally { setBusy(false); }
  };

  return (
    <div data-testid="forgot-password-page" className="max-w-md mx-auto px-4 py-14">
      <div className="bg-white rounded-3xl border border-stone-200/80 p-8 shadow-sm">
        <h1 className="font-serif text-3xl text-forest text-center">Şifremi Unuttum</h1>
        {sent ? (
          <div className="mt-6 text-center">
            <div data-testid="forgot-success" className="text-sm text-emerald-700 bg-emerald-50 border border-emerald-200 rounded-xl p-4 leading-relaxed">
              E-posta adresiniz kayıtlıysa sıfırlama bağlantısı gönderildi. Lütfen gelen kutunuzu (ve spam klasörünü) kontrol edin — bağlantı 30 dakika geçerlidir.
            </div>
            <Link to="/giris" data-testid="forgot-back-login" className="inline-flex items-center gap-1.5 mt-5 text-sm font-semibold text-forest hover:underline"><ArrowLeft className="w-4 h-4" /> Giriş sayfasına dön</Link>
          </div>
        ) : (
          <>
            <p className="text-stone-500 text-sm text-center mt-2">E-posta adresinizi girin, size şifre sıfırlama bağlantısı gönderelim.</p>
            <form onSubmit={submit} className="space-y-4 mt-6">
              <input data-testid="forgot-email" type="email" required className="w-full h-12 px-4 rounded-xl border border-stone-300 bg-white text-sm focus:outline-none focus:ring-2 focus:ring-forest/30 focus:border-forest" placeholder="E-posta" value={email} onChange={(e) => setEmail(e.target.value)} />
              <button data-testid="forgot-submit" disabled={busy} className="w-full flex items-center justify-center gap-2 bg-forest hover:bg-forest-dark disabled:bg-stone-400 text-white font-semibold py-3.5 rounded-xl transition-colors">
                <Mail className="w-4 h-4" /> {busy ? "Gönderiliyor..." : "Sıfırlama Bağlantısı Gönder"}
              </button>
            </form>
            <p className="text-center mt-5"><Link to="/giris" data-testid="forgot-back-login" className="inline-flex items-center gap-1.5 text-sm font-semibold text-forest hover:underline"><ArrowLeft className="w-4 h-4" /> Giriş sayfasına dön</Link></p>
          </>
        )}
      </div>
    </div>
  );
}
